import { render, staticRenderFns } from "./IntroMobile.vue?vue&type=template&id=28e1c670"
import script from "./IntroMobile.vue?vue&type=script&lang=js"
export * from "./IntroMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports